import { render, staticRenderFns } from "./AmazonSES.vue?vue&type=template&id=04fed87a&scoped=true"
import script from "./AmazonSES.vue?vue&type=script&lang=js"
export * from "./AmazonSES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fed87a",
  null
  
)

export default component.exports